// import { CheckCircle, ChevronRight, Building2, Calendar, Mail, Phone, Rocket, X, User } from "lucide-react";
import { CheckCircle, ChevronRight,  Calendar, X } from "lucide-react";
import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import BenefitSlider from "./BenefitsSlider";
import { fetchActivePrograms, saveStartupIdeaWithoutPayment } from "../../utils/api";
import toast from "react-hot-toast";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { NextArrow, PrevArrow } from "./PrevArrows";
import ProgramTimer from "./ProgramTimer";
import { useQuery } from "@tanstack/react-query";
import ProgramTimerSkeleton from "./ProgramTimeSkeleton";
const InvestmentPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [stepError, setStepError] = useState("");

  const [formData, setFormData] = useState({
    founderEmail: "",
    founderName: "",
    founderPhone: "",
    founderPlace: "", 
    startupName: "",
    startupStage: "",
    founderBackground: "",
    pitchDeckLink: "",
    programType: "investment-readiness",

  });

  const validateStepOne = () => {
  if (!formData.founderName.trim()) {
    setStepError("Founder Name is required");
    return false;
  }

  if (!formData.founderEmail.trim()) {
    setStepError("Email Address is required");
    return false;
  }

  if (!/\S+@\S+\.\S+/.test(formData.founderEmail)) {
    setStepError("Please enter a valid Email Address");
    return false;
  }

  if (!formData.founderPhone.trim()) {
    setStepError("Phone Number is required");
    return false;
  }

  if (!/^\d{10}$/.test(formData.founderPhone)) {
    setStepError("Please enter a valid 10-digit Phone Number");
    return false;
  }

  if(!formData.founderPlace.trim()) {
    setStepError("Enter your City and State");
    return false;

}
  if (!formData.startupName.trim()) {
    setStepError("Startup Name is required");
    return false;
  }

  if (!formData.startupStage.trim()) {
    setStepError("Startup Stage is required");
    return false;
  }

  if (!formData.founderBackground.trim()) {
    setStepError("Founder Background is required");
    return false;
  }

  if (!formData.pitchDeckLink.trim()) {
    setStepError("Pitch Deck Drive Link is required");
    return false;
  }

  setStepError("");
  return true;
};
 

  const [isSubmitting, setIsSubmitting] = useState(false)

  const [processing, setProcessing] = useState(false);

  // const [currentStep, setCurrentStep] = useState(1)

  const handleSubmit = async (e) => {
    // e.preventDefault();

    setProcessing(true);
    // console.log(formData)
    try {
      // 1. Validate inputs
      if (!formData.founderName || !formData.founderPhone || !formData.founderEmail) {
        toast.error("Please fill all required fields");
        setProcessing(false);
        return;
      }

      console.log("Submitting Data:", formData);
      const responce = await saveStartupIdeaWithoutPayment(formData)

      setIsSubmitting(true)
   toast.success(responce.message || "Application submitted successfully!");
setFormData({
  founderName: "",
  founderEmail: "",
  founderPhone: "",
  founderPlace: "",
  startupName: "",
  startupStage: "",
  founderBackground: "",
  pitchDeckLink: "",
  programType: "investment-readiness",
});
setProcessing(false);
setIsModalOpen(false);
console.log(formData)

    } catch (error) {
  console.error("FULL ERROR:", error);

  if (error.response) {
    console.log("Backend Response:", error.response.data);
    console.log("Status:", error.response.status);
  }

  toast.error(
    error.response?.data?.message ||
    error.message ||
    "Something went wrong"
  );
}

    finally {
      // setIsSubmitting(false)
      setProcessing(false);
    }
  };

  const settings = {
    dots: false,
    infinite: true,              
    speed: 600,              

    autoplay: true,            
    autoplaySpeed: 3000,         
    pauseOnHover: true,          
    pauseOnFocus: true,        
    cssEase: "ease-in-out",      

    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,

    slidesToShow: 2,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024, // Tablet
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // Mobile
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  // const dummyProgram = {
  //   name: "TACTOS Investment Readiness Bootcamp – Cohort 3",
  //   venue: "Bangalore",
  //   description:
  //     "A 5-day intensive, on-site bootcamp designed to prepare early-stage startups for investment readiness, mentor validation, and live investor pitching.",
  //   startDate: "2025-01-20T00:00:00.000Z",
  //   endDate: "2025-01-25T00:00:00.000Z",
  //   expiryDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(), 
  // };


  const { data, isLoading } = useQuery({
    queryKey: ["readiness"],
    queryFn: () => fetchActivePrograms("bootcamp")
  })

  useEffect(() => {
    console.log(data)
  }, [data])


  return (
    <>

      {isLoading ? <ProgramTimerSkeleton /> : data?.data?.length > 0 ? data?.data?.map((each) => (
        <ProgramTimer program={each} setIsModalOpen={setIsModalOpen} />
      )) : ""}


      {/* -------------------------------------- */}
      {/* WHAT IS BOOTCAMP */}
      {/* -------------------------------------- */}
      <section className="py-7 px-6 md:px-20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

          {/* LEFT CONTENT */}
          <div className="order-2 md:order-1">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-6">
              What Is <span className="text-[#fd3e3d]">TACTOS Bootcamp?</span>
            </h2>

            <p className="text-gray-700 text-lg max-w-xl leading-relaxed mb-10 text-justify" >
              Our bootcamps are fast-paced, immersive learning sprints designed for founders
              who want to prepare their startup for investment in under a week.
            </p>

            <ul className="text-gray-800 space-y-3 text-lg">
              <li className="flex items-center gap-3">
                <CheckCircle className="text-[#fd3e3d]" /> On-site
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-[#fd3e3d]" /> Mentor-driven
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-[#fd3e3d]" /> Outcome-oriented
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-[#fd3e3d]" /> Live Investor Pitching Session
              </li>
            </ul>
          </div>

          {/* RIGHT IMAGE */}
          <div className="order-1 md:order-2 flex justify-center md:justify-end">
            <img
              src="/readinesspageimage.webp"
              alt="Bootcamp"
              className="rounded-xl shadow-lg w-full max-w-md"
            />
          </div>

        </div>
      </section>



      {/* -------------------------------------- */}
      {/* HOW IT WORKS – Residency Style */}
      {/* -------------------------------------- */}
      <section className="py-5 px-6 md:px-20 ">
        <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-14 tracking-wide">
          HOW IT <span className="text-[#fd3e3d]">WORKS</span>
        </h3>

        <div className="space-y-10 max-w-6xl mx-auto">

          {/* Row 1 */}
          <div className="flex flex-col md:flex-row justify-center gap-6">
            {[
              [
                "Register",
                "Founders apply online by submitting their startup details. This marks the beginning of your journey into the TACTOS bootcamp"
              ],
              [
                "Screening Call",
                "Shortlisted applicants attend a screening call to assess potential. Only serious, high-intent founders proceed to the next stage"
              ],
              [
                "Acceptance",
                "Selected founders receive official acceptance into the program and gain access to the 5–7 day intensive on-site bootcamp"
              ],
            ].map(([title, desc], i, arr) => (
              <div
                key={i}
                className="relative w-full md:w-[32%] border p-6 rounded-xl  shadow-sm"
              >
                <h4 className="font-bold text-xl mb-2">{title}</h4>
                <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

                {/* Red Arrow */}
                {i !== arr.length - 1 && (
                  <div
                    className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
                  ></div>
                )}
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* -------------------------------------- */}
      {/* PROGRAM SCHEDULE – Premium Cards */}
      {/* -------------------------------------- */}
      {/* -------------------------------------- */}
      {/* PROGRAM SCHEDULE – Arrow Flow Style */}
      {/* -------------------------------------- */}
      <section className="py-10 px-6 md:px-20 bg-gray-50">
        <h2 className="text-4xl font-extrabold text-center mb-14">
          PROGRAM <span className="text-[#fd3e3d]">SCHEDULE</span>
        </h2>

        <div className="space-y-10 max-w-6xl mx-auto">

          {/* Row 1 */}
          <div className="flex flex-col md:flex-row justify-center gap-6">
            {[
              [
                "Founder Mindset & Idea Validation",
                "Self-Awareness | Problem Discovery | Rapid Validation | Founder Narrative | Idea Validation",
              ],
              [
                "Foundation & Investor Mindset",
                "Fundability Criteria | Market Sizing | Risk Assessment | Investor Psychology",
              ],
              [
                "Business Model Deep Dive",
                "Value Proposition | Revenue Architecture | Competitor Mapping | Scalability Design",
              ],
            ].map(([title, desc], i) => (
              <div
                key={i}
                className="relative w-full md:w-[32%] border p-6 rounded-xl  shadow-sm"
              >
                <h3 className="text-xl font-bold mb-2">{title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

                {/* Arrow */}
                <div
                  className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2 
            w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent 
            border-l-[#fd3e3d] drop-shadow-md"
                ></div>
              </div>
            ))}
          </div>

          {/* Row 2 */}
          <div className="flex flex-col md:flex-row justify-center gap-6">
            {[
              [
                "Financial Readiness",
                "Unit Economics | Valuation Basics | Projections Building | Fundraising Plan",
              ],
              [
                "Go-To-Market & Traction",
                "ICP Definition | GTM Funnel | Early Traction | Growth Experiments | Roadmap",
              ],
              [
                "Ultimate Pitch Preparation",
                "Deck Structure | Storytelling | Data Positioning | Q&A Handling",
              ],
            ].map(([title, desc], i, arr) => (
              <div
                key={i}
                className="relative w-full md:w-[32%] border p-6 rounded-xl  shadow-sm"
              >
                <h3 className="text-xl font-bold mb-2">{title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

                {/* Arrow */}
                {i !== arr.length - 1 && (
                  <div
                    className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
                  ></div>
                )}
              </div>
            ))}
          </div>

        </div>



        {/* Pitch Day Highlight */}
        <div className="max-w-6xl mx-auto mt-20">
          <div className="relative bg-white border-2 border-gray rounded-2xl p-10 md:p-14 shadow-lg">

            {/* Badge */}
            <span
              className="absolute -top-4 left-1/2 -translate-x-1/2
  bg-[#fd3e3d] text-white text-sm font-semibold
  px-6 py-1 rounded-full whitespace-nowrap">
              FINAL MILESTONE
            </span>


            {/* Title */}
            <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-4">
              The <span className="text-[#fd3e3d]">Pitch Day</span>
            </h3>

            {/* Subtitle */}
            <p className="text-center text-gray-600 text-lg mb-10 max-w-3xl mx-auto">
              Where founders present refined, investor-ready startups to mentors,
              angels, and ecosystem leaders.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              {[
                "Investor Showcase",
                "Live Expert Feedback",
                "Funding Pathways",
                "Strategic Networking",
                "Incubation Access",
                "Growth Opportunities",
              ].map((item, i) => (
                <div
                  key={i}
                  className="border rounded-xl py-4 px-3 font-medium text-gray-800 
          hover:border-[#fd3e3d] transition"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>

      </section>

      <section className="w-full  px-4">
        <h2 className="text-4xl font-extrabold text-center mb-14">
          <span className="text-[#fd3e3d]">BENEFITS</span>
        </h2>
        <div className="max-w-6xl mx-auto">
          <Slider {...settings}>
            {[
              {
                title: "One-to-One Investor Access",
                description:
                  "Pitch directly to serious, growth-focused investors who understand early-stage potential. Get personalised feedback, refine your funding strategy, and unlock real capital opportunities to scale your startup with clarity and confidence."
              },
              {
                title: "Access to the TACTOS Dashboard",
                description:
                  "Manage everything in one place including startup tools, growth insights, financial planning, pitch materials, and progress tracking. The TACTOS Dashboard acts as your digital command center for building, refining, and scaling your company."
              },
              {
                title: "80 Lakhs Worth of Tech Credits",
                description:
                  "Leverage premium cloud, AI, automation, and developer software credits to build faster, reduce costs, and accelerate product development. Ideal for MVP creation, scaling infrastructure, and rapid technology growth."
              },
              {
                title: "1:1 Mentorship with World-Class Mentors",
                description:
                  "Receive personalised guidance from global experts, industry leaders, and successful founders. Gain strategic clarity, solve business challenges, validate decisions, and accelerate startup growth through focused one-on-one mentorship."
              },
              {
                title: "Discounted Payment Gateway Solutions",
                description:
                  "Access founder-only, low-fee payment gateway plans starting at just 0.9%. Streamline transactions, improve customer conversions, and reduce operational costs with secure, startup-friendly payment integrations."
              },

            ].map((data, i) => (
              <div key={i}>
                {/* 👇 spacing wrapper */}
                <div className="px-2">
                  {/* 👇 actual card */}
                  <div className="relative border p-6 rounded-xl h-auto md:h-[170px] shadow-sm bg-white">
                    <h4 className="font-bold text-xl mb-2">
                      {data.title}
                    </h4>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {data.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>


        <div className="max-w-6xl mx-auto mt-24">
          <Slider {...settings}>
            {[

              {
                title: "Startup-Friendly TACTOS CRM & ERP",
                description:
                  "Get lifetime discounted access to TACTOS CRM for up to 10 users, along with scalable ERP tools for operations, sales, and workflow automation. Upgrade to enterprise-grade systems at highly affordable prices."
              },
              {
                title: "Discounted Event Entry",
                description:
                  "Attend TACTOS workshops, summits, founder meetups, and investor showcases at exclusive discounted rates. Stay connected to the ecosystem, learn from leaders, and gain year-round visibility."
              },
              {
                title: "Incubation & Working Facilities Access",
                description:
                  "Work from professional, startup-friendly spaces with meeting rooms, incubation support, mentor access, and collaborative environments designed to boost productivity, networking, and rapid business development."
              },
              {
                title: "Discounted Travel Options",
                description:
                  "Enjoy reduced travel costs for conferences, investor meetings, and client visits. Founder-friendly travel benefits help you save money while expanding your network across regions."
              },
              {
                title: "Year-Round Investor Access",
                description:
                  "Unlock continuous access to verified angel investors, micro-VCs, and strategic partners. Schedule meetings, request feedback, explore funding pathways, and build long-term investor relationships."
              }
            ].map((data, i) => (
              <div key={i}>
                {/* 👇 spacing wrapper */}
                <div className="px-2">
                  {/* 👇 actual card */}
                  <div className="relative border p-6 rounded-xl h-auto md:h-[170px] shadow-sm bg-white">
                    <h4 className="font-bold text-xl mb-2">
                      {data.title}
                    </h4>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {data.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>


      {/* -------------------------------------- */}
      {/* BENEFITS – SLIDER */}
      {/* -------------------------------------- */}
      {/* <BenefitSlider /> */}

      {/* -------------------------------------- */}
      {/* APPLY NOW CTA */}
      {/* -------------------------------------- */}
      <section className="py-10">
        <div className="text-center max-w-3xl mx-auto">

          <h2 className="text-3xl font-bold mb-6">
            Turn your startup into an{" "}
            <span className="text-[#fd3e3d]">investable venture</span>
          </h2>

          <button
            // to="/instructions/investment"
            onClick={() => {
              // setCurrentStep(1);
              setIsModalOpen(true);
            }}
            className="inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635]
              text-white font-semibold py-4 px-10 rounded-xl shadow-lg hover:shadow-xl transition"
          >
            Apply Now
            <ChevronRight className="w-5 h-5" />
          </button>

        </div>
      </section>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setIsModalOpen(false)}
          />
<div className="relative w-full max-w-2xl max-h-[90vh] rounded-2xl shadow-2xl bg-white flex flex-col">
          {/* <div className="relative w-full max-w-xl max-h-[98vh] rounded-2xl overflow-hidden shadow-2xl bg-white"> */}

            {/* HEADER */}
            <div className="bg-black p-6 text-center relative">
              <button
                onClick={() => setIsModalOpen(false)}
                className="absolute top-4 right-4 text-white/80 hover:text-white"
              >
                <X className="w-6 h-6" />
              </button>

              <div className="flex justify-center mb-3">
                <div className="bg-[#fd3e3d] p-3 rounded-full">
                  <Calendar className="w-8 h-8 text-white" />
                </div>
              </div>

              <h3 className="text-white text-2xl font-bold">Application Form</h3>
            </div>


              {/* STEP 1 */}
<form className="flex-1 overflow-y-auto p-6 space-y-5">                
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

    <div>
      <label className="text-sm text-black/70">
        Founder Name
      </label>
      <input
        value={formData.founderName}
        onChange={(e) =>
          setFormData({
            ...formData,
            founderName: e.target.value,
          })
        }
        placeholder="Founder Name"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Email Address
      </label>
      <input
        type="email"
        value={formData.founderEmail}
        onChange={(e) =>
          setFormData({
            ...formData,
            founderEmail: e.target.value,
          })
        }
        placeholder="Email Address"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Phone Number
      </label>
      <input
        type="tel"
        maxLength={10}
        value={formData.founderPhone}
        onChange={(e) =>
          setFormData({
            ...formData,
            founderPhone: e.target.value.replace(/\D/g, ""),
          })
        }
        placeholder="Phone Number"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    {/*  */}
 <div>
      <label className="text-sm text-black/70">
        Place
      </label>
      <input
        value={formData.founderPlace}
        onChange={(e) =>
          setFormData({
            ...formData,
            founderPlace: e.target.value,
          })
        }
        placeholder="City & State"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Startup Name
      </label>
      <input
        value={formData.startupName}
        onChange={(e) =>
          setFormData({
            ...formData,
            startupName: e.target.value,
          })
        }
        placeholder="Startup Name"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div      >
      <label className="text-sm text-black/70">
        Startup Stage
      </label>
      <select
        value={formData.startupStage}
        onChange={(e) =>
          setFormData({
            ...formData,
            startupStage: e.target.value,
          })
        }
        // className="w-full px-4 py-3 rounded-xl border border-black/20"
         className={`w-full px-4 py-3 rounded-xl border border-black/20 ${
    formData.startupStage ? "text-black" : "text-gray-500"
  }`}
      >
        <option value="">Select Stage</option>
        <option>Idea</option>
        <option>Prototype</option>
        <option>MVP</option>
        <option>Users</option>
        <option>Revenue</option>
      </select>
    </div>

    <div className="md:col-span-2">
      <label className="text-sm text-black/70">
        Founder Background
      </label>
      <textarea
        rows={4}
        value={formData.founderBackground}
        onChange={(e) =>
          setFormData({
            ...formData,
            founderBackground: e.target.value,
          })
        }
        placeholder="Tell us about yourself and your experience"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div className="md:col-span-2">
      <label className="text-sm text-black/70">
        Pitch Deck (Google Drive Link) 
      </label>
      <input
        type="url"
        value={formData.pitchDeckLink}
        onChange={(e) =>
          setFormData({
            ...formData,
            pitchDeckLink: e.target.value,
          })
        }
        placeholder="https://drive.google.com/..."
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    {stepError && (
      <p className="md:col-span-2 text-sm text-red-500">
        {stepError}
      </p>
    )}

  </div>
             <div className="border-t p-4 flex justify-end bg-white">
  <button
    type="button"
    onClick={() => {
      const isValid = validateStepOne();

      if (!isValid) return;

      handleSubmit();
    }}
    disabled={processing}
    className="px-6 py-3 bg-[#fd3e3d] text-white rounded-lg font-medium hover:bg-[#e63635]"
  >
    {processing ? "Submitting..." : "Submit Application"}
  </button>
</div>   
              </form>

    </div>  
    </div>
     
)}  

 </>
);
};
   
export default InvestmentPage;
